"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.iggMessages = exports.Igg = void 0;
const schema_1 = require("../../../schema");
var Igg;
(function (Igg) {
    Igg["POSITIVE"] = "POSITIVE";
    Igg["NEGATIVE"] = "NEGATIVE";
    Igg["IN_PROGRESS"] = "IN_PROGRESS";
})(Igg || (exports.Igg = Igg = {}));
exports.iggMessages = {
    [Igg.POSITIVE]: {
        id: "htx.microbiologicalProcedures.toxoplasmaSerology.igg.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [Igg.NEGATIVE]: {
        id: "htx.microbiologicalProcedures.toxoplasmaSerology.igg.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [Igg.IN_PROGRESS]: {
        id: "htx.microbiologicalProcedures.toxoplasmaSerology.igg.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const igg = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(Igg.POSITIVE),
    schema_1.Schema.singleChoiceItem(Igg.NEGATIVE),
    schema_1.Schema.singleChoiceItem(Igg.IN_PROGRESS)
])
    .interpretation({ vocab: "htx", code: "toxoplasma_serology_igg" })
    .tag({ vocab: "snomed", code: "315199001" })
    .tag({ vocab: "loinc", code: "22580-5" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ igg })
    .interpretation({ vocab: "htx", code: "toxoplasma_serology" })
    .tag({ vocab: "snomed", code: "104305007" })
    .tag({ vocab: "loinc", code: "20464-4" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" });
